import { render, staticRenderFns } from "./SingleMandate.vue?vue&type=template&id=23d8b715&scoped=true&"
import script from "./SingleMandate.vue?vue&type=script&lang=js&"
export * from "./SingleMandate.vue?vue&type=script&lang=js&"
import style0 from "./SingleMandate.vue?vue&type=style&index=0&id=23d8b715&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d8b715",
  null
  
)

export default component.exports